var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"subtitle",staticStyle:{"margin-bottom":"10px"}},[_vm._t("title")],2),_c('p',[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }